"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeContainingCoordinates = exports.placeListNearCoordinates = void 0;
const geolib_1 = require("geolib");
const first_1 = __importDefault(require("lodash/first"));
const node_geometry_library_1 = require("node-geometry-library");
const CoordinatesArray_1 = require("../models/CoordinatesArray");
const Place_1 = require("../models/Place");
const geofire_1 = require("../util/geofire");
function placeListNearCoordinates(coordinates, distanceM, firestore) {
    return (0, geofire_1.geofireFirestoreQuery)('places', 'location.geohash', data => data.location.coordinates, coordinates, distanceM, firestore, Place_1.placeDeserialize);
}
exports.placeListNearCoordinates = placeListNearCoordinates;
async function placeContainingCoordinates(coordinates, firestore) {
    const places = await placeListNearCoordinates(coordinates, 10000, firestore);
    const matchingPlaces = places.filter(place => {
        var _a;
        return (_a = place.polygons) === null || _a === void 0 ? void 0 : _a.find(polygon => (0, geolib_1.isPointInPolygon)((0, CoordinatesArray_1.latLngLiteralFromCoordinatesArray)(coordinates), node_geometry_library_1.PolyUtil.decode(polygon.coordinatesEncoded, 5)));
    });
    return (0, first_1.default)(matchingPlaces);
}
exports.placeContainingCoordinates = placeContainingCoordinates;
